import React, { useEffect, useState } from "react";

const DialogBoxSkeleton = ({ isOpen, onClose, children, disableBackdropClick = false }) => {
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        if (isOpen) {
            // Disable scrolling when dialog opens
            document.body.style.overflow = 'hidden';

            // Re-enable scrolling when dialog closes
            return () => {
                document.body.style.overflow = 'auto';
            };
        }
    }, [isOpen]);

    const handleMouseDown = (e) => {
        // Only set dragging if the click started on the overlay
        if (e.target === e.currentTarget) {
            setIsDragging(true);
        }
    };

    const handleMouseUp = (e) => {
        // Only close if we were dragging and the mouse up is on the overlay
        if (isDragging && e.target === e.currentTarget && !disableBackdropClick) {
            onClose();
        }
        setIsDragging(false);
    };


    if (isOpen) {
        return (
            <div
                className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-75"
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
            >
                {children}

            </div>
        );
    }

    return null;
}

export default DialogBoxSkeleton;